import {PhoneDetails, SelectOption, SessionStorage} from '@chekin/core';
import {IS_LEADER_GUEST_STORAGE_KEY} from 'utils/constants';
import {
  AgreementClauseKeyFormName,
  AGREEMENT_CLAUSE_FIELDS,
  LOCATIONS_FIELDS,
  SELECT_FIELDS,
  PHONE_FIELDS,
  DATE_FIELDS,
} from './constants';

const isSelectField = (value: unknown): value is (typeof SELECT_FIELDS)[number] => {
  return SELECT_FIELDS.includes(value as (typeof SELECT_FIELDS)[number]);
};

const isPhoneField = (value: unknown): value is (typeof PHONE_FIELDS)[number] => {
  return PHONE_FIELDS.includes(value as (typeof PHONE_FIELDS)[number]);
};

const isLocationField = (value: unknown): value is (typeof LOCATIONS_FIELDS)[number] => {
  return LOCATIONS_FIELDS.includes(value as (typeof LOCATIONS_FIELDS)[number]);
};

const isDateField = (value: unknown): value is (typeof DATE_FIELDS)[number] => {
  return DATE_FIELDS.includes(value as (typeof DATE_FIELDS)[number]);
};

const isAgreementClauseField = (fieldName: string) => {
  return AGREEMENT_CLAUSE_FIELDS.includes(
    fieldName as (typeof AGREEMENT_CLAUSE_FIELDS)[number],
  );
};

const isSelectOptionTypeValid = (value: unknown): value is SelectOption => {
  return Boolean((value as SelectOption)?.value && (value as SelectOption)?.label);
};

const isPhoneNumberTypeValid = (value: unknown): value is PhoneDetails => {
  return Boolean((value as PhoneDetails)?.number && (value as PhoneDetails)?.code);
};

const buildAgreementClausesFormData = (clauses: Record<string, boolean>) => {
  return Object.entries(clauses).reduce((accumulator, [id, value]) => {
    accumulator[`${AgreementClauseKeyFormName}${id}`] = value;
    return accumulator;
  }, {} as Record<string, boolean>);
};

const getIsLeaderGuest = (): boolean | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  let isLeaderGuestFromUrl = urlParams.get(IS_LEADER_GUEST_STORAGE_KEY);

  if (isLeaderGuestFromUrl === null && window.location.hash.includes('?')) {
    const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
    isLeaderGuestFromUrl = hashParams.get(IS_LEADER_GUEST_STORAGE_KEY);
  }

  if (isLeaderGuestFromUrl !== null) {
    return isLeaderGuestFromUrl === 'true';
  }

  const isLeaderGuest = SessionStorage.get<string>(IS_LEADER_GUEST_STORAGE_KEY);
  if (isLeaderGuest === null || isLeaderGuest === 'undefined') {
    return undefined;
  }
  return JSON.parse(isLeaderGuest);
};

const appendLeaderParam = (path: string, isLeader?: boolean): string => {
  if (isLeader === undefined) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${IS_LEADER_GUEST_STORAGE_KEY}=${isLeader}`;
};

export {
  isSelectField,
  isPhoneField,
  isLocationField,
  isDateField,
  isSelectOptionTypeValid,
  isPhoneNumberTypeValid,
  isAgreementClauseField,
  buildAgreementClausesFormData,
  getIsLeaderGuest,
  appendLeaderParam,
};
